import { IconButton, Typography } from "@mui/material";
import React from "react";
import { StarsIcon } from "../../../../Custom-imeges/StarsIcon";
import { ImprovePromptIcon } from "../../../../Custom-imeges/ImprovePromptIcon";

interface ImprovePromptBtnProps {
  handelImprovePrompt: () => void;
  isDisabled: boolean;
  inputValue: string;
}

export const ImprovePromptBtn = ({
  handelImprovePrompt,
  isDisabled,
  inputValue,
}: ImprovePromptBtnProps) => {
  return (
    <IconButton
      className="input-failed-improve-text"
      onClick={handelImprovePrompt}
      disabled={isDisabled || inputValue?.length === 0}
      sx={{
        opacity: isDisabled || inputValue?.length === 0 ? 0.5 : 1,
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "transparent",
        },
      }}
    >
      <ImprovePromptIcon className="pro-plan-icon suites clear-input-icn"/>
      <Typography>Improve <span>prompt</span></Typography>
    </IconButton>
  );
};
